import angular from "angular"

export interface IConstants {
    portalAppPath?: string;
    serviceAppPath?: string;
    appPath?: string;
    serviceUrl?: string;
    omsServiceUrl?: string;
    imagesFolder?: string;
    wmsOSServiceUrl?: string;
    wmsServiceUrl?: string;
    defaultMapZoom?: number;
    defaultMapLocation?: number[];
    userId?: string;
    userName?: string;
    login?: string;
    isAdmin?: string;
    initialPermissions?: string[];
    isActiveDirectoryUser?: boolean;
    minRequiredPasswordLength?: number;
    WorkItemTitle?: string;
    ProjectTitle?: string;
    PluralWorkItemTitle?: string;
    centralAPIVersion?: number;
    FeatureToggles: {
        Notifications?: boolean,
        ShowMap?: boolean
    },
    appVersion?: string
}

const Constants: IConstants = window.GFC || {};

angular.module("GFC.constants", [])
    .constant("Constants", Constants);
